import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { fireAddToCart, fireInitiateCheckout } from './MetaPixel';
import { useLanguage } from '../context/LanguageContext';
export function AuthorityClose() {
  const {
    t
  } = useLanguage();
  const handleCtaClick = () => {
    fireAddToCart();
    fireInitiateCheckout();
  };
  return <Section background="charcoal" className="text-center py-24 border-t border-luxury-gold/10" data-id="element-3">
      <div className="max-w-3xl mx-auto space-y-10" data-id="element-4">
        <h2 className="font-serif text-4xl md:text-6xl text-white leading-tight" data-id="element-5">
          {t.authorityClose.headline.line1} <br data-id="element-6" />
          <span className="text-luxury-gold italic" data-id="element-7">
            {t.authorityClose.headline.span}
          </span>
        </h2>

        <div className="pt-4" data-id="element-8">
          <Button id="cta-final" href="https://learn.alexaaanarvaez.in/cart/43580187443265:1" variant="outline" className="min-w-[200px]" onClick={handleCtaClick} data-id="element-9">
            {t.authorityClose.cta}
          </Button>
        </div>

        <p className="text-xs text-luxury-gray/40 uppercase tracking-widest pt-16" data-id="element-10">
          {t.authorityClose.copyright}
        </p>
      </div>
    </Section>;
}